import {
  AGREEMENT_TYPE,
  IAgreementTemplateResponse,
} from 'services/templates/agreement-template/types';
import {
  IContractTemplateForm,
  IContractTemplateTreeItemForm,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { parseAgreementType } from 'utils/components/contract-template/agreement/agreementTemplate.utils';

export const agreementTemplateQueryToFormItem = (
  agreement: IAgreementTemplateResponse,
  lowestAvailableId?: string
): IContractTemplateTreeItemForm | undefined => {
  const { id, position, type, ...formAgreement } = agreement;
  const agreementType = parseAgreementType(type);

  if (agreementType === AGREEMENT_TYPE.text) {
    return {
      type: TEMPLATE_TYPE.agreement,
      content: {
        type: AGREEMENT_TYPE.text,
        selectAgreementTemplate: {
          ...formAgreement,
          options: [formAgreement.defaultValue],
        },
        textAgreementTemplate: formAgreement,
      },
      id: lowestAvailableId ?? id,
      children: [],
    };
  }

  if (agreementType === AGREEMENT_TYPE.select) {
    const { options, ...textAgreementTemplate } = formAgreement;

    return {
      type: TEMPLATE_TYPE.agreement,
      content: {
        type: AGREEMENT_TYPE.select,
        selectAgreementTemplate: {
          title: formAgreement.title,
          defaultValue: formAgreement.defaultValue,
          options: options ?? [],
        },
        textAgreementTemplate: textAgreementTemplate,
      },
      id: lowestAvailableId ?? id,
      children: [],
    };
  }

  if (agreementType === AGREEMENT_TYPE.paragraph) {
    return {
      type: TEMPLATE_TYPE.agreement,
      content: {
        type: AGREEMENT_TYPE.paragraph,
        paragraphAgreementTemplate: formAgreement,
        textAgreementTemplate: null,
        selectAgreementTemplate: null,
      },
      id: lowestAvailableId ?? id,
      children: [],
    };
  }

  return undefined;
};

export const agreementTemplateQueryToParagraphFormItem = (
  agreement: IAgreementTemplateResponse,
  lowestAvailableId?: string
): IContractTemplateTreeItemForm | undefined => {
  const agreementType = parseAgreementType(agreement.type);

  if (agreementType === AGREEMENT_TYPE.paragraph) {
    return agreementTemplateQueryToFormItem(agreement, lowestAvailableId);
  }

  if (agreementType !== AGREEMENT_TYPE.text) {
    return undefined;
  }

  const { id, title, defaultValue } = agreement;

  return {
    type: TEMPLATE_TYPE.agreement,
    content: {
      type: AGREEMENT_TYPE.paragraph,
      paragraphAgreementTemplate: { title, defaultValue },
      textAgreementTemplate: null,
      selectAgreementTemplate: null,
    },
    id: lowestAvailableId ?? id,
    children: [],
  };
};

export const agreementTemplateQueryToParagraphForm = (
  agreement: IAgreementTemplateResponse
): IContractTemplateForm => {
  return contractTemplateUtil.agreement.initialValues(
    agreementTemplateQueryToParagraphFormItem(agreement, '2')
  );
};

export const agreementTemplateQueryToForm = (
  agreement: IAgreementTemplateResponse
): IContractTemplateForm => {
  return contractTemplateUtil.agreement.initialValues(
    agreementTemplateQueryToFormItem(agreement, '2')
  );
};
